import React, { useState } from "react";
import "./ContactSection.css";
import { FaPhoneAlt, FaEnvelope } from "react-icons/fa";

export default function ContactSection() {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    company: "",
    city: "",
    service: "",
    message: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const whatsappNumber = "9899811123";

    const whatsappMessage = `
Hello DENSAT Team 👋

📌 *New Callback Request*

👤 Name: ${formData.name}
📞 Phone: ${formData.phone}
📧 Email: ${formData.email}
🏢 Company: ${formData.company || "N/A"}
🏙 City: ${formData.city}
🛠 Service Required: ${formData.service}

📝 Message:
${formData.message || "No additional message"}
    `;

    const encodedMessage = encodeURIComponent(whatsappMessage.trim());

    window.open(
      `https://wa.me/${whatsappNumber}?text=${encodedMessage}`,
      "_blank"
    );

    setIsSubmitting(false);

    setFormData({
      name: "",
      phone: "",
      email: "",
      company: "",
      city: "",
      service: "",
      message: "",
    });
  };

  return (
    <section className="contact-main-section">
      <div className="contact-container">

        {/* LEFT COLUMN */}
        <div className="contact-left">
          <h2 className="contact-left-title">Get in Touch</h2>
          <p className="contact-left-sub">
            We’re here to help you transform your facility management experience.
          </p>

          <div className="contact-info-block">
            <div className="icon">
              <FaPhoneAlt />
            </div>
            <div>
              <h4>Phone</h4>
              <p>+91-9899811123</p>
            </div>
          </div>

          <div className="contact-info-block">
            <div className="icon">
              <FaPhoneAlt />
            </div>
            <div>
              <h4>Phone</h4>
              <p>+91-9971118390</p>
            </div>
          </div>

          <div className="contact-info-block">
            <div className="icon">
              <FaEnvelope />
            </div>
            <div>
              <h4>Email</h4>
              <p>infodel@densat.com</p>
            </div>
          </div>

          <div className="business-hours-box">
            <h4>Business Hours</h4>
            <p>
              Monday - Saturday: 9:00 AM - 6:00 PM
              <br />
              Sunday: Closed
            </p>
            <span className="support-link">
              24/7 Emergency Support Available
            </span>
          </div>
        </div>

        {/* RIGHT COLUMN */}
        <div className="contact-right">
          <h3 className="form-title">Request a Callback</h3>

          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Name *</label>
              <input
                type="text"
                name="name"
                placeholder="Your full name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label>Phone *</label>
              <input
                type="text"
                name="phone"
                placeholder="+91 XXXXX XXXXX"
                value={formData.phone}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label>Email *</label>
              <input
                type="email"
                name="email"
                placeholder="your.email@company.com"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label>Company Name</label>
              <input
                type="text"
                name="company"
                placeholder="Your company"
                value={formData.company}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label>City *</label>
              <input
                type="text"
                name="city"
                placeholder="Your city"
                value={formData.city}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label>Service Required *</label>
              <input
                type="text"
                name="service"
                placeholder="Service you need"
                value={formData.service}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group full-width">
              <label>Message</label>
              <textarea
                name="message"
                placeholder="Tell us about your requirements..."
                value={formData.message}
                onChange={handleChange}
              ></textarea>
            </div>

            <button type="submit" className="submit-btn" disabled={isSubmitting}>
              {isSubmitting ? "Redirecting..." : "Submit & WhatsApp ✈"}
            </button>
          </form>
        </div>

      </div>
    </section>
  );
}
